export default __webpack_public_path__ + "static/media/myCompany.ae938017.svg";